/**
 * Removes diacritics, transforms to lowercase and trims whitespace
 */

const sanitizeString = (str: string) => {
    return str
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '')
        .toLowerCase()
        .replace(/\s+/g, '');
};

export default sanitizeString;
